import React from 'react';
import { FaTimes, FaUser, FaUsers, FaLink, FaEnvelope } from 'react-icons/fa';
import './feed.shared.css';

const ShareModal = ({ isOpen, onClose, post, onShowFeedback }) => {
    if (!isOpen) return null;

    const handleShare = (type) => {
        console.log(`Compartiendo post ${post.id} vía ${type}`);
        // Implementar lógica real según sea necesario
        onShowFeedback?.('Compartir', `Publicación compartida vía ${type}`, 'success');
        onClose();
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content share-modal" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h3>Compartir publicación</h3>
                    <button className="close-btn" onClick={onClose}><FaTimes /></button>
                </div>
                <div className="modal-body">
                    <div className="share-options">
                        <button className="share-option-btn" onClick={() => handleShare('profile')}>
                            <FaUser className="icon" />
                            <span>Compartir en mi perfil</span>
                        </button>
                        <button className="share-option-btn" onClick={() => handleShare('group')}>
                            <FaUsers className="icon" />
                            <span>Enviar a un grupo</span>
                        </button>
                        <button className="share-option-btn" onClick={() => handleShare('link')}>
                            <FaLink className="icon" />
                            <span>Copiar enlace</span>
                        </button>
                        <button className="share-option-btn" onClick={() => handleShare('email')}>
                            <FaEnvelope className="icon" />
                            <span>Enviar por email</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ShareModal;
